//@ts-nocheck
import { roundCurrency } from './currencyHelper';

export const getSecondaryFullPaymentAmount = ({
  balanceDue,
  selectedAddOnsTotal,
  bookingPaidInFull
}) => {
  const balanceAmount = bookingPaidInFull ? 0 : Number(balanceDue) || 0;
  const addOnsAmount = Number(selectedAddOnsTotal) || 0;

  return roundCurrency(balanceAmount + addOnsAmount);
};
